import { render } from "./PageHeaderDrawer.vue?vue&type=template&id=66a1bcc2"
import script from "./PageHeaderDrawer.vue?vue&type=script&lang=js"
export * from "./PageHeaderDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__